module.exports = __webpack_public_path__ + "static/media/logo.76dde3c9.svg";